import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      "h-11 w-full rounded-soft border border-night-blue/15 bg-white px-4 text-sm text-night-blue",
      "placeholder:text-night-blue/70 focus:border-leaf-green focus:outline-none focus:ring-1 focus:ring-leaf-green",
      "disabled:bg-medical-grey disabled:opacity-60",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";
